module.exports = __webpack_public_path__ + "img/calendar-alt.5f0e9348.svg";